import ReactDOM from 'react-dom';

const Portal = ({ children }: { children: React.ReactNode }) => ReactDOM.createPortal(children, document.querySelector('#root') as Element | DocumentFragment);

export default Portal;